import { QueryParams } from "@/api";

interface RecommendationsFilter extends QueryParams {
  shape: string;
  limit: number;
}

export const recommendationsFilterMock: RecommendationsFilter = {
  shape: "card",
  limit: 8,
};

// Mock data reflects the real recommendations endpoint response shape, where:
// - `id` is the article header ID (not the story ID)
// - `metadata.article_header_fragment.story_id` holds the story ID that
//   viewmodel components expect. See `normalizeRecommendationIds` in
//   useRecommendationsQuery.ts for how this gets resolved before use.
export const recommendationsMock = [
  {
    generated_date: "2025-01-10T19:04:40.445Z",
    id: "clrgmceu5000w0louebf1vmow",
    description: "Fast-food giants overwork teenagers",
    display_date: "2024-02-12",
    images: [
      {
        generated_date: "2025-01-10T19:04:40.445Z",
        id: "clrgm32dd00443b6cjstn6wp6",
        alt_text: "A McDonald's restaurant in Rutland, Vermont.",
        auto: "format,compress",
        credit: "Photo: John Tully/The Washington Post",
        crop: "faces,edges",
        fit: "crop",
        fp_x: 0.5,
        fp_y: 0.5,
        fp_z: 1,
        height: 4521,
        url: "https://newsela.imgix.net/alexandria/image/2024/01/16/child-labor-fastfood-c41c62b0-b327-11ee-b1ff-dac856996ee6-ga29n50o86.jpg",
        width: 6782,
        viewmodel_type: "image",
        formatted_url:
          "https://newsela.imgix.net/alexandria/image/2024/01/16/child-labor-fastfood-c41c62b0-b327-11ee-b1ff-dac856996ee6-ga29n50o86.jpg?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=4521&w=6782",
      },
    ],
    metadata: {
      article_type: "ARTICLE_NEWS",
      content_type: "ARTICLE",
      date_lite_product_grant_expires: null,
      grade_levels: [3, 5, 7, 9, 12],
      has_formative: false,
      has_power_words: true,
      lexile_levels: [610, 620, 870, 910, 1040, 1040, 1200, 1210, 1410, 1490],
      languages: ["LANG_EN", "LANG_ES"],
      maturity_range: [6, 12],
      reading_skills: [
        "Connecting People, Events, Ideas",
        "Main Idea",
        "Summarization",
        "Key Details",
      ],
      article_header_fragment: {
        slug: "child-labor-fast-food",
        story_id: "clrglry1a00063b6c9gm5g08b",
        header_language: "LANG_EN",
      },
    },
    title:
      "Fast-food giants overwork teenagers, driving America's child labor crisis",
    url: "/view/clrglry1a00063b6c9gm5g08b/",
    viewmodel_type: "card",
  },
  {
    generated_date: "2025-01-16T15:27:09.459Z",
    id: "cl1mcpwme000a0epqamhde08n",
    description:
      "Los panda rojos son criaturas fascinantes y estos son algunos datos que quizás no sabía.",
    display_date: "2022-04-27",
    images: [
      {
        generated_date: "2025-01-16T15:27:09.459Z",
        id: "cl1mirwn000000boja8j1a0ry",
        alt_text: "Red panda taking a step onto a tree branch.",
        auto: "format,compress",
        credit: "Photo: Sopianti Abdullah/EyeEm/Getty Images",
        crop: "faces,edges",
        fit: "crop",
        fp_x: 0.5,
        fp_y: 0.52,
        fp_z: 1,
        height: 1414,
        url: "https://newsela.imgix.net/article_media/2022/04/amazing-red-panda-facts-125b4416.jpg",
        width: 2121,
        viewmodel_type: "image",
        formatted_url:
          "https://newsela.imgix.net/article_media/2022/04/amazing-red-panda-facts-125b4416.jpg?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.52&fp-z=1.0&h=1414&w=2121",
      },
    ],
    metadata: {
      article_type: "ARTICLE_NEWS",
      content_type: "ARTICLE",
      date_lite_product_grant_expires: null,
      grade_levels: [3, 5, 7, 9, 12],
      has_formative: false,
      has_power_words: false,
      lexile_levels: [840, 1190, 1200, 610, 1020, 1190, 620, 1320, 1020, 790],
      languages: ["LANG_ES", "LANG_EN"],
      maturity_range: [4, 8],
      reading_skills: [
        "Word Meaning & Choice",
        "Connecting People, Events, Ideas",
        "Reading Skill 1 - What the Text Says",
      ],
      article_header_fragment: {
        slug: "amazing-red-panda-facts",
        story_id: "cl1mcpwme000a0epqamhde08n",
        header_language: "LANG_ES",
      },
    },
    title: "Conozca estos datos sorprendentes sobre los pandas rojos",
    url: "/view/cl1mcpwme000a0epqamhde08n/",
    viewmodel_type: "card",
    visibility_markers: [
      {
        reason: "DISTRICT_ADVISORY",
        group_id: "cm6131nxs00000tngr0dkradw",
        grade_minimum: 8,
        grade_maximum: 12,
        block_teacher_view: false,
        message: null,
        learn_more_url: null,
        flagged_at_my_admin_level: false,
        veil: false,
        date_lite_product_grant_expires: null,
      },
    ],
  },
];
